import React, { useEffect, useState } from 'react';
import Dropdown from "../common/filter/dropdown";
import { CloseIcon } from '../../assets/icons/close-icon';
import HidingColumns from "./hidingColumns";
import { ENDPOINTS } from '../../js/api/_config';
import axios from 'axios';
import { useSelector } from 'react-redux';

const Filter = ({
    toggleFilter,
    patientListColumns,
    hiddenColumns,
    handleToggleColumn,
    hideLastCol,
    filterValues,
    selectedValues,
    clearFilter,
    showAllCol
}) => {

    const trailData = useSelector((state) => state.trails_name.data);
    const [stateList, setStateList] = useState([]);
    const [cityList, setCityList] = useState([]);
    const [Studies, setStudies] = useState(trailData || []);

    const [selectedState, setSelectedState] = useState([]);
    const [selectedCities, setSelectedCities] = useState([]);
    const [selectedStudies, setSelectedStudies] = useState([]);

    const getStates = async () => {
        try {
            const response = await axios.get(`${ENDPOINTS.PATIENT.GET_STATES}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching states:', error);
            return [];
        }
    };

    const getStateCities = async (stateIds) => {
        if (stateIds?.length > 0) {
            try {
                const response = await axios.get(`${ENDPOINTS.PATIENT.GET_STATES_CITY}`, {
                    params: { stateIDs: stateIds.join(",") }
                });
                if (response.data.success && response.data.data) {
                    const formatted = response.data.data.map((x, index) => ({
                        name: x.city.trim(),
                        value: index
                    }));
                    setCityList(formatted);
                    return formatted;
                }
            } catch (error) {
                console.error('Error fetching cities:', error);
            }
        } else {
            setCityList([]);
        }
        return [];
    };

    const fetchCountryState = async () => {
        const res = await getStates();
        if (res.data && res.data.length > 0) {
            setStateList(res.data.map(x => ({ name: x.stateName.trim(), value: x.stateID })));
        }
    };

    const applyFilter = () => {
        const filterObj = {
            State: selectedState,
            Cities: selectedCities,
            Studies: selectedStudies
        };

        const states = stateList
            .filter(s => filterObj.State.includes(s.value))
            .map(s => s.name)
            .join(",");

        const cities = cityList
            .filter(c => filterObj.Cities.includes(c.value))
            .map(c => c.name)
            .join(",");

        const trialnames = Studies
            .filter(s => filterObj.Studies.includes(s.value))
            .map(s => s.name)
            .join(",");

        filterValues({ states, cities, trialnames, hiddenColumns });
    };

    // Fetch states on mount
    useEffect(() => {
        fetchCountryState();
    }, []);

    // Sync studies from Redux
    useEffect(() => {
        if (trailData?.length > 0) {
            setStudies(trailData.map(x => ({ name: x.trialName, value: x.trialID })));
        }
    }, [trailData]);

    // Restore filter values after data loads
    useEffect(() => {
        const restoreFilterValues = async () => {
            if (!stateList.length || !Studies.length) return;

            const filterObj = {
                State: selectedValues.states ? selectedValues.states.split(",").map(s => s.trim()) : [],
                Cities: selectedValues.cities ? selectedValues.cities.split(",").map(s => s.trim()) : [],
                Studies: selectedValues.trialnames ? selectedValues.trialnames.split(",").map(s => s.trim()) : []
            };

            const stateIds = stateList
                .filter(s => filterObj.State.includes(s.name))
                .map(s => s.value);
            setSelectedState(stateIds);

            const cities = await getStateCities(stateIds);
            const cityIds = cities
                .filter(c => filterObj.Cities.includes(c.name))
                .map(c => c.value);
            setSelectedCities(cityIds);

            const studyIds = Studies
                .filter(s => filterObj.Studies.includes(s.name))
                .map(s => s.value);
            setSelectedStudies(studyIds);
        };

        restoreFilterValues();
    }, [selectedValues, stateList, Studies]);

    return (
        <>
            <div className={`w-[570px] bg-white h-screen flex flex-col z-10`}>

                <div className="border-b border-[#B2ACC9] bg-[#fff] w-full sticky top-[75px]" style={{ borderColor: 'rgb(200, 214, 230)' }}>
                    <div className="flex justify-between items-center w-full px-5 py-6">
                        <h2 className="font-semibold text-left">Filters</h2>
                        {/* <button onClick={() => { }}><CloseIcon /> </button> */}
                    </div>
                </div>
                <div className='flex flex-col h-[calc(100vh-150px)] '>

                    <div className=" p-4 overflow-y-auto p-6 h-[calc(100vh-330px)]">
                        <div className="">
                            <div className="flex mb-2 items-center">

                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M17.5 8.33301C17.5 14.1663 10 19.1663 10 19.1663C10 19.1663 2.5 14.1663 2.5 8.33301C2.5 6.34388 3.29018 4.43623 4.6967 3.02971C6.10322 1.62318 8.01088 0.833008 10 0.833008C11.9891 0.833008 13.8968 1.62318 15.3033 3.02971C16.7098 4.43623 17.5 6.34388 17.5 8.33301Z" stroke="#1B2A3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M10 10.833C11.3807 10.833 12.5 9.71372 12.5 8.33301C12.5 6.9523 11.3807 5.83301 10 5.83301C8.61929 5.83301 7.5 6.9523 7.5 8.33301C7.5 9.71372 8.61929 10.833 10 10.833Z" stroke="#1B2A3D" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>


                                <span className="text-lg font-medium ml-4">Locations</span>
                                {/* <div><button onClick={toggleFilter}><CloseIcon className="w-5 h-5 " /></button></div> */}
                            </div>

                            <div className="pt-2">
                                <Dropdown
                                    //key={selectedState}
                                    title={"Select State"}
                                    options={stateList}
                                    selectedOptions={selectedState}
                                    handleChange={(newSelection) => {
                                        setSelectedState(newSelection)
                                        getStateCities(newSelection);
                                    }}
                                />
                                <Dropdown
                                    //key={selectedCities}
                                    title={"Select City"}
                                    options={cityList}
                                    selectedOptions={selectedCities}
                                    handleChange={(newSelection) => {
                                        setSelectedCities(newSelection)
                                    }}
                                />
                            </div>
                        </div>

                        <hr className="mb-4 mt-4" />
                        <div className="">
                            <div className="flex mb-2 items-center">

                                <svg width="18" height="20" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M3.21756 17.5379L3.6584 16.9311L3.21756 17.5379ZM2.29576 16.6161L2.90253 16.1753L2.29576 16.6161ZM15.7042 16.6161L15.0975 16.1753L15.7042 16.6161ZM14.7824 17.5379L14.3416 16.9311L14.7824 17.5379ZM14.7824 2.46275L15.2233 1.85599L14.7824 2.46275ZM15.7042 3.38455L15.0975 3.82539L15.7042 3.38455ZM3.21756 2.46275L3.6584 3.06952L3.21756 2.46275ZM2.29576 3.38455L2.90253 3.82539L2.29576 3.38455ZM9.95512 5.49642L10.0724 6.23718L9.95512 5.49642ZM8.6515 5.49642L8.53417 6.23718H8.53417L8.6515 5.49642ZM5.66667 14.2503C5.25245 14.2503 4.91667 14.5861 4.91667 15.0003C4.91667 15.4145 5.25245 15.7503 5.66667 15.7503V14.2503ZM12.3333 15.7503C12.7475 15.7503 13.0833 15.4145 13.0833 15.0003C13.0833 14.5861 12.7475 14.2503 12.3333 14.2503V15.7503ZM5.66667 10.917C5.25245 10.917 4.91667 11.2528 4.91667 11.667C4.91667 12.0812 5.25245 12.417 5.66667 12.417V10.917ZM12.3333 12.417C12.7475 12.417 13.0833 12.0812 13.0833 11.667C13.0833 11.2528 12.7475 10.917 12.3333 10.917V12.417ZM5.66667 7.58366C5.25245 7.58366 4.91667 7.91945 4.91667 8.33366C4.91667 8.74787 5.25245 9.08366 5.66667 9.08366V7.58366ZM12.3333 9.08366C12.7475 9.08366 13.0833 8.74787 13.0833 8.33366C13.0833 7.91945 12.7475 7.58366 12.3333 7.58366V9.08366ZM15.75 9.16699V10.8337H17.25V9.16699H15.75ZM2.25 10.8337V9.16699H0.75V10.8337H2.25ZM9 17.5837C7.42091 17.5837 6.29683 17.5826 5.4285 17.4886C4.57421 17.396 4.05688 17.2206 3.6584 16.9311L2.77672 18.1447C3.47352 18.6509 4.28502 18.8734 5.26693 18.9798C6.23481 19.0847 7.45432 19.0837 9 19.0837V17.5837ZM0.75 10.8337C0.75 12.3793 0.748971 13.5988 0.853834 14.5667C0.960218 15.5486 1.18275 16.3601 1.689 17.0569L2.90253 16.1753C2.61301 15.7768 2.43766 15.2594 2.34511 14.4052C2.25103 13.5368 2.25 12.4128 2.25 10.8337H0.75ZM3.6584 16.9311C3.36834 16.7204 3.11326 16.4653 2.90253 16.1753L1.689 17.0569C1.99226 17.4743 2.35932 17.8414 2.77672 18.1447L3.6584 16.9311ZM15.75 10.8337C15.75 12.4128 15.749 13.5368 15.6549 14.4052C15.5623 15.2594 15.387 15.7768 15.0975 16.1753L16.311 17.0569C16.8173 16.3601 17.0398 15.5486 17.1462 14.5667C17.251 13.5988 17.25 12.3793 17.25 10.8337H15.75ZM9 19.0837C10.5457 19.0837 11.7652 19.0847 12.7331 18.9798C13.715 18.8734 14.5265 18.6509 15.2233 18.1447L14.3416 16.9311C13.9431 17.2206 13.4258 17.396 12.5715 17.4886C11.7032 17.5826 10.5791 17.5837 9 17.5837V19.0837ZM15.0975 16.1753C14.8867 16.4653 14.6317 16.7204 14.3416 16.9311L15.2233 18.1447C15.6407 17.8414 16.0077 17.4743 16.311 17.0569L15.0975 16.1753ZM17.25 9.16699C17.25 7.62131 17.251 6.4018 17.1462 5.43392C17.0398 4.45201 16.8173 3.64051 16.311 2.94371L15.0975 3.82539C15.387 4.22387 15.5623 4.7412 15.6549 5.59549C15.749 6.46382 15.75 7.5879 15.75 9.16699H17.25ZM14.3416 3.06952C14.6317 3.28026 14.8867 3.53534 15.0975 3.82539L16.311 2.94371C16.0077 2.52631 15.6407 2.15925 15.2233 1.85599L14.3416 3.06952ZM2.25 9.16699C2.25 7.5879 2.25103 6.46382 2.34511 5.59549C2.43766 4.7412 2.61301 4.22387 2.90253 3.82539L1.689 2.94371C1.18275 3.64051 0.960218 4.45201 0.853834 5.43392C0.748971 6.4018 0.75 7.62131 0.75 9.16699H2.25ZM2.77672 1.85599C2.35932 2.15925 1.99226 2.52632 1.689 2.94371L2.90253 3.82539C3.11326 3.53534 3.36834 3.28026 3.6584 3.06952L2.77672 1.85599ZM9.83779 4.75565C9.48368 4.81174 9.12294 4.81174 8.76882 4.75565L8.53417 6.23718C9.04375 6.31789 9.56286 6.31789 10.0724 6.23718L9.83779 4.75565ZM13.8369 1.67927C12.8019 2.71356 12.0543 3.44934 11.4107 3.95621C10.7782 4.45427 10.3064 4.68143 9.83779 4.75565L10.0724 6.23718C10.8918 6.10741 11.6001 5.71634 12.3387 5.13464C13.0662 4.56173 13.8806 3.75619 14.8972 2.74031L13.8369 1.67927ZM9 2.41699C10.3867 2.41699 11.4253 2.41752 12.2526 2.48254C13.0775 2.54736 13.6186 2.67234 14.0294 2.87946L14.7048 1.54011C14.0391 1.20444 13.272 1.05802 12.3701 0.987147C11.4707 0.916463 10.364 0.916992 9 0.916992V2.41699ZM14.0294 2.87946C14.1404 2.93547 14.2437 2.9984 14.3416 3.06952L15.2233 1.85599C15.0589 1.73656 14.8865 1.63176 14.7048 1.54011L14.0294 2.87946ZM3.52987 2.56082C4.60347 3.63438 5.45314 4.48296 6.2039 5.08384C6.96572 5.69357 7.69124 6.10368 8.53417 6.23718L8.76882 4.75565C8.28679 4.6793 7.80142 4.44116 7.14121 3.91275C6.46994 3.37549 5.68644 2.59603 4.5905 1.50014L3.52987 2.56082ZM9 0.916992C7.80436 0.916992 6.80866 0.916725 5.9803 0.963628C5.15266 1.01049 4.43894 1.1064 3.81555 1.3215L4.30481 2.73946C4.73489 2.59107 5.28782 2.50524 6.0651 2.46123C6.84165 2.41726 7.78913 2.41699 9 2.41699V0.916992ZM3.81555 1.3215C3.43784 1.45183 3.09403 1.62546 2.77672 1.85599L3.6584 3.06952C3.84461 2.93423 4.05369 2.82611 4.30481 2.73946L3.81555 1.3215ZM5.66667 15.7503H12.3333V14.2503H5.66667V15.7503ZM5.66667 12.417H12.3333V10.917H5.66667V12.417ZM5.66667 9.08366H12.3333V7.58366H5.66667V9.08366Z" fill="#373737" />
                                </svg>


                                <span className="text-lg font-medium ml-4">Studies</span>

                            </div>

                            <div className="space-y-2  pt-2">
                                <Dropdown
                                    //key={selectedStudies}
                                    title={"Select"}
                                    options={Studies}
                                    selectedOptions={selectedStudies}
                                    handleChange={(newSelection) => {
                                        setSelectedStudies(newSelection)
                                    }} />
                            </div>

                        </div>
                        <hr className="mb-4 mt-4" />
                        <div className="mb-[5px]">
                            <div className="flex mb-2 items-center">

                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M15.8333 2.5H4.16667C3.24619 2.5 2.5 3.24619 2.5 4.16667V15.8333C2.5 16.7538 3.24619 17.5 4.16667 17.5H15.8333C16.7538 17.5 17.5 16.7538 17.5 15.8333V4.16667C17.5 3.24619 16.7538 2.5 15.8333 2.5Z" stroke="#373737" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M9.67188 17.3102L9.67188 3.14355" stroke="#373737" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                <span className="text-lg font-medium ml-4">Edit Column</span>
                            </div>

                            <div className="space-y-2 p-5">
                                <div className="flex flex-wrap gap-2 lg:flex-col space-y-2 pl-2">
                                    <label key="All" className="flex items-center space-x-2">
                                        <input
                                            type="checkbox"
                                            checked={hiddenColumns.length == 0}
                                            onChange={() => showAllCol(hiddenColumns.length == 0 ? false : true)}
                                            className="h-4 w-4"
                                        />
                                        <span className="text-sm">Select All</span>
                                    </label>

                                    {(patientListColumns.filter(x => x.name != "") || []).map((col, idx,arr) => (
                                        <label key={col.name} className="flex items-center space-x-2">
                                            <input
                                                type="checkbox"
                                                checked={!hiddenColumns.includes(col.name)}
                                                onChange={() => handleToggleColumn(col.name)}
                                                disabled={idx === arr.length - 1} 
                                                className="h-4 w-4"
                                            />
                                            <span className="text-sm">{col.name}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="fixed shadow-[0_-4px_20px_0_rgba(0,0,0,0.25)] p-5 bottom-0 w-full bg-white pl-8 flex gap-5 z-10">

                    <button
                        onClick={applyFilter}
                        className="px-7 py-1 text-base rounded-md border primary_btn transition-all duration-500"
                    >
                        Apply
                    </button>
                    {/* <button
                        onClick={toggleFilter}
                        className="btn-primary mr-[20px] secondary_btn"
                    >
                        Cancel
                    </button> */}
                    <button
                        onClick={clearFilter}
                        className="px-[20px] py-[10px] text-[14px] font-medium rounded-md border secondary_btn transition-all duration-500 undefined"
                    >
                        Clear
                    </button>
                </div>

            </div>
        </>
    );
};

export default Filter;
